"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toServerLocale = exports.normalizeLang = void 0;
var types_1 = require("./types");
var IS_LANG_ZH_CN = /^zh(_|-)cn$/i;
var IS_LANG_ZH_TW = /^zh(_|-)tw$/i;
var IS_LANG_JP = /^ja((_|-)[a-zA-Z]{2})?$/i;
var IS_LANG_EN = /^en((_|-)[a-zA-Z]{2})?$/i;
var ServerLocale = {
    'cn': types_1.E_LocaleServer.zh_CN,
    'tw': types_1.E_LocaleServer.zh_TW,
    'en': types_1.E_LocaleServer.en_US,
    'jp': types_1.E_LocaleServer.ja_JP,
};
function normalizeLang(lang) {
    if (IS_LANG_ZH_CN.test(lang))
        return 'cn';
    else if (IS_LANG_ZH_TW.test(lang))
        return 'tw';
    else if (IS_LANG_EN.test(lang))
        return 'en';
    else if (IS_LANG_JP.test(lang))
        return 'jp';
    return undefined;
}
exports.normalizeLang = normalizeLang;
function toServerLocale(locale) {
    return ServerLocale[locale];
}
exports.toServerLocale = toServerLocale;
//# sourceMappingURL=convert.js.map